export default __webpack_public_path__ + "static/media/avatar2.7ea352c8.png";